import { createRoot } from 'react-dom/client'
import '@fontsource/ibm-plex-sans/400.css'
import '@fontsource/ibm-plex-sans/500.css'
import '@fontsource/ibm-plex-sans/600.css'
import '@fontsource/ibm-plex-mono/400.css'
import '@fontsource/ibm-plex-mono/600.css'
import App from './App'
import { ErrorBoundary } from './ErrorBoundary'
import { LanguageProvider } from './i18n'
import './styles.css'
import './styles-v2.css'
import './brand-gate.css'
import './product-dark.css'
import './two-modes.css'

createRoot(document.getElementById('root')!).render(<ErrorBoundary><LanguageProvider><App /></LanguageProvider></ErrorBoundary>)
